export const heroData = {
  title: '深情陪伴每一天',
  subtitle: '久久伊人，专注情感陪伴与品质生活的首选品牌。以真诚与用心守护每一段珍贵关系，让美好情感久久延续。',
  primaryCta: '探索品牌故事',
  secondaryCta: '浏览精选文章',
};

export const valueCards = [
  {
    id: 'warm-companion',
    icon: 'ri-heart-line',
    title: '温暖陪伴',
    description: '无论是平淡日常还是重要时刻，久久伊人始终以温柔的方式陪伴在你身边，用心聆听每一份情感需求。',
    color: 'primary',
  },
  {
    id: 'emotional-resonance',
    icon: 'ri-empathize-line',
    title: '情感共鸣',
    description: '我们深谙情感的力量，通过专业知识与真诚交流帮助每一位用户找到情感归属，建立深层连接。',
    color: 'accent',
  },
  {
    id: 'quality-experience',
    icon: 'ri-vip-crown-line',
    title: '品质体验',
    description: '从内容到服务，久久伊人始终追求卓越品质，为追求美好生活的你打造极致的情感生活体验。',
    color: 'secondary',
  },
];

export const brandStats = [
  { label: '服务用户', value: '500,000+' },
  { label: '优质文章', value: '2,000+' },
  { label: '品牌年限', value: '12 年' },
  { label: '满意度', value: '98.6%' },
];

export const ctaData = {
  title: '开启您的久久之旅',
  subtitle: '让美好情感久久延续，从今天开始温暖相伴',
  buttonText: '立即联系我们',
  buttonLink: '/about#contact',
};